import { ModalName, ModalPropsType } from 'store/modals/types';
import { selectModalProps } from 'store/modals/selectors';
import { closeModal as closeModalAction, openModal as openModalAction } from 'store/modals/actions';

import { setCancellationCandidate } from '../../store/subscriptions/actions';

import { useDispatch, useSelector } from 'hooks';

export const useModals = () => {
    const dispatch = useDispatch();
    const modalProps = useSelector(selectModalProps);

    const openModal = <T extends ModalName>(modalId: T, props?: ModalPropsType[T]) => {
        dispatch(openModalAction(modalId, props));
    };

    const closeModal = () => {
        dispatch(setCancellationCandidate(null));
        dispatch(closeModalAction());
    };

    return { openModal, closeModal, modalProps };
};
